var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 29.536,
    height: 32.492,
    viewBox: "0 0 29.536 32.492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.112,
    y1: 0.779,
    x2: 0.844,
    y2: 0.001,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff4565"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#fa4362"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#ee3d5a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.834,
    stopColor: "#d9344d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ca2e43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.824,
    y1: 0.036,
    x2: 0.133,
    y2: 0.746,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0.042,
    y1: 1.511,
    x2: 0.841,
    y2: 1.511,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.441,
    y1: 1.511,
    x2: 1.162,
    y2: 1.511,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6d3326",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.241,
    stopColor: "#6a3124",
    stopOpacity: 0.063
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.492,
    stopColor: "#622e1f",
    stopOpacity: 0.251
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746,
    stopColor: "#542816",
    stopOpacity: 0.565
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42210b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 0.5,
    y1: -0.887,
    x2: 0.5,
    y2: -1.23,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 0.7,
    y1: 0.336,
    x2: 1.05,
    y2: 0.336,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.702,
    y1: 0.048,
    x2: 0.897,
    y2: -0.147,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fdb4ba",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#fdb3b9",
    stopOpacity: 0.016
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.246,
    stopColor: "#fdb2b8",
    stopOpacity: 0.067
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.373,
    stopColor: "#fdb0b6",
    stopOpacity: 0.145
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#fdacb3",
    stopOpacity: 0.263
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632,
    stopColor: "#fda8af",
    stopOpacity: 0.412
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.762,
    stopColor: "#fda4aa",
    stopOpacity: 0.588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.892,
    stopColor: "#fd9ea5",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe99a0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.5,
    y1: 1.526,
    x2: 0.5,
    y2: 0.938,
    xlinkHref: "#linear-gradient-4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "power_14378915",
    transform: "translate(-23.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M43.113,76.367a2.468,2.468,0,0,0,1.1,2.049,8.053,8.053,0,0,1,3.61,6.718v3.6A8.062,8.062,0,0,1,39.763,96.8h-3.6A8.056,8.056,0,0,1,28.1,88.743v-3.6a8.053,8.053,0,0,1,3.61-6.718,2.451,2.451,0,0,0-2.69-4.1,12.945,12.945,0,0,0-5.823,10.8v3.6A12.965,12.965,0,0,0,36.166,101.7h3.6A12.965,12.965,0,0,0,52.736,88.731v-3.6a12.961,12.961,0,0,0-5.823-10.816,2.457,2.457,0,0,0-3.8,2.055Z",
    transform: "translate(0 -69.218)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M79.718,95.2a2.467,2.467,0,0,0,.844,3.159,8.053,8.053,0,0,1,3.61,6.718v3.6a8.062,8.062,0,0,1-8.063,8.063H72.5a8.056,8.056,0,0,1-8.056-8.056v-3.6a8.053,8.053,0,0,1,3.61-6.718,2.468,2.468,0,0,0,1.1-2.049,2.428,2.428,0,0,0-.26-1.11,10.511,10.511,0,0,0-6.9,9.877v3.6A10.512,10.512,0,0,0,72.511,119.2h3.6a10.512,10.512,0,0,0,10.511-10.511v-3.6A10.528,10.528,0,0,0,79.718,95.2Z",
    transform: "translate(-36.339 -89.161)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M219.755,0a2.453,2.453,0,0,1,2.455,2.455v11.3a2.455,2.455,0,1,1-4.91,0V2.455A2.453,2.453,0,0,1,219.755,0Z",
    transform: "translate(-181.787)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M219.755,0a2.453,2.453,0,0,1,2.455,2.455v11.3a2.455,2.455,0,1,1-4.91,0V2.455A2.453,2.453,0,0,1,219.755,0Z",
    transform: "translate(-181.787)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M47.826,277.1v1.941a8.062,8.062,0,0,1-8.063,8.063h-3.6a8.056,8.056,0,0,1-8.056-8.056v-1.941H23.2v1.941a12.965,12.965,0,0,0,12.966,12.966h3.6a12.965,12.965,0,0,0,12.966-12.966v-1.941h-4.91Z",
    transform: "translate(0 -259.522)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M264.944,74.356a2.451,2.451,0,0,0-2.69,4.1,8.053,8.053,0,0,1,3.61,6.718v3.6a8.062,8.062,0,0,1-8.063,8.063H256v4.9h1.8a12.965,12.965,0,0,0,12.966-12.966v-3.6A12.965,12.965,0,0,0,264.944,74.356Z",
    transform: "translate(-218.032 -69.256)",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M106.588,117.009v-3.6a12.942,12.942,0,0,0-3.946-9.306l-3.47,3.47a8.044,8.044,0,0,1,2.506,5.836v3.6a8.062,8.062,0,0,1-8.063,8.063h-3.6a8.059,8.059,0,0,1-5.842-2.506l-3.47,3.47a12.966,12.966,0,0,0,9.319,3.939h3.6A12.965,12.965,0,0,0,106.588,117.009Z",
    transform: "translate(-53.852 -97.496)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M217.3,139.3v4.916a2.455,2.455,0,1,0,4.91,0V139.3Z",
    transform: "translate(-181.787 -130.463)",
    fill: "url(#linear-gradient-8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.965802837dfdbde5233ce9db43e3da0c.svg";
export { ForwardRef as ReactComponent };